import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { isNumber, isEmpty } from 'lodash/fp';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import * as actions from 'actions/assign';
import { Icon } from 'ui';
import SelectableCollection from './shared/SelectableCollection';

class AssignStep extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  get isActive() {
    return this.props.name === this.props.activeStep;
  }

  handleClick() {
    const { locked, setActiveStep } = this.props;
    if (!locked) {
      setActiveStep();
    }
  }

  render() {
    const { count, label, name, selectables, locked, children } = this.props;
    const className = classNames('AssignStep', {
      'AssignStep--active': this.isActive,
      'AssignStep--disabled': locked,
    });

    return (
      <div
        className={className}
        onClick={this.handleClick}
        onKeyDown={e => e.key === 'Enter' && this.handleClick()}
      >
        <div className="AssignStep-header">
          <span className="AssignStep-title">
            <Text variant={TEXT_VARIANTS.BODY_BOLD}>{label}</Text>
            {locked && (
              <Icon name="lock" className="AssignStep-lockIcon mb-3" />
            )}
          </span>
          {isNumber(count) && <span className="AssignStep-count">{count}</span>}
        </div>
        {!isEmpty(children) && children}
        {!isEmpty(selectables) && (
          <SelectableCollection name={name} data={selectables} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeStep: state.activeStep,
});

const mapDispatchToProps = (dispatch, { name }) => ({
  setActiveStep() {
    dispatch(actions.setActiveStep(name));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignStep);
